import React from 'react';
import './index.css';
import { WarningOutlined } from '@material-ui/icons';

const ConfirmDialog = (props) => {
  const {title, onConfirm, onClose} = props;

  return (
    <>
      <div className="confirm-overlay" onClick={onClose} aria-hidden="true" />
      <section className="confirm" role="dialog" aria-modal="true">
       <div>
        <div className='confirm-header'>
            <WarningOutlined />
            <h3>Attenzione: Modifica Bundle</h3>
          </div>
          <p>
            Questo servizio è attualmente incluso nel bundle{" "}
            "<strong>{title}</strong>" con uno sconto promozionale.
          </p>
          <p className='confirm-alert'>
            Procedendo con la modifica, rimuoverai automaticamente tutti gli altri servizi inclusi nel pacchetto.
          </p>
          <p>
            Sei sicuro di voler continuare?
          </p>
        </div>
        <div className='confirm-buttons'>
          <button onClick={onClose}>Annulla</button>
          <button onClick={onConfirm} className='submit'>Si, Rimuovi Bundle</button>
        </div>
      </section>
    </>
  )
}

export default ConfirmDialog;